<script>
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'The quantity has been updated successfully.': 'A quantidade foi atualizada com sucesso.',
      'Unable to add the product to your cart, please try again.': 'Não foi possível adicionar o produto em seu carrinho, tente novamente.',
      'remove': 'remover',
      'This product does not exist or is no longer available.': 'Este produto não existe ou não está mais disponível.',
      'The quantity entered is not available at the moment.': 'A quantidade informada não está disponível no momento.',
    },
    es: {
      'The quantity has been updated successfully.': 'La cantidad se actualizó con éxito.',
      'Unable to add the product to your cart, please try again.': 'No fue posible agregar el producto a tu carrito, inténtalo de nuevo.',
      'remove': 'eliminar',
      'This product does not exist or is no longer available.': 'Este producto no existe o ya no está disponible.',
      'The quantity entered is not available at the moment.': 'La cantidad ingresada no está disponible en este momento.',
    },
  },
  props: {
    id: {
      default: ""
    },
    quantity: {
      default: ""
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      qty: this.$props.quantity,
      saveTimer: null,
    };
  },
  methods: {
    saveNow() {
      clearTimeout(this.saveTimer)
      this.buyProduct()
    },
    scheduleSave() {
      clearTimeout(this.saveTimer)
      this.saveTimer = setTimeout(() => {
        this.buyProduct()
      }, 600)
    },
    buyProduct() {
      if (this.qty != this.$props.quantity) {
        this.loading = true

        api
          .post('store/cart', {
            id: this.$props.id,
            qty: this.qty,
            plus: 'no'
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.$toast.success(this.t('The quantity has been updated successfully.'))

              localStorage.removeItem('cart');
              this.$parent.getCart()
            } else {
              this.qty = this.$props.quantity
              this.$toast.error(this.t(response.data.message))
            }

            this.loading = false
          })
          .catch(error => {
            if (error) {
              this.$toast.error(this.t('Unable to add the product to your cart, please try again.'))
            }
          })
      }
    },
    editItem(id, qty) {
      if (id) {
        api
          .post('store/cart', {
            id: id,
            qty: qty
          })
          .then(response => {
            if (response.data.status == 'success') {
              localStorage.removeItem('cart');
              this.$parent.getCart()
            }
          })
      }
    },
    decrementQty() {
      const newQty = parseInt(this.qty) - 1

      if (newQty >= 1) {
        this.qty = newQty
        this.scheduleSave()
      }
    },
    incrementQty() {
      this.qty = parseInt(this.qty) + 1
      this.scheduleSave()
    },
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="saveNow()" style="width:140px;" class="m-auto">
      <b-form-group class="m-0" label-for="qty">
        <b-input-group>
          <b-input-group-prepend>
            <b-button style="width:40px;" class="btn-block font-size-20 py-0 px-2 text-center" type="button" variant="secondary" :disabled="loading || parseInt(qty) <= 1" v-on:click="decrementQty()"><i class="bx bx-minus align-top mt-1"></i></b-button>
          </b-input-group-prepend>
          <b-form-input class="text-center" v-model="qty" type="text" inputmode="numeric" v-mask="'###'" autocomplete="off" @blur="saveNow()"></b-form-input>
          <b-input-group-append>
            <b-button style="width:40px;" class="btn-block font-size-20 py-0 px-2 text-center" type="button" variant="secondary" :disabled="loading" v-on:click="incrementQty()"><i class="bx bx-plus align-top mt-1"></i></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-form>
    <button class="btn btn-link p-0 text-dark font-size-12" v-on:click="editItem(id, 0)">{{ t('remove') }}</button>
  </div>
</template>